export default __webpack_public_path__ + "static/media/replace.8c80e623.webp";